export default __webpack_public_path__ + "static/Team_Member_A_R-cf2cf0393a2f6a6e4a88557a0bac2c4b.png";